(function ($) {
  $(document).ready(function () {

    const $section = $('#presse-section');
    if (!$section.length) return;

    const $grid = $('#presse-grid');
    const $loadMore = $('#presse-load-more');
    const $loading = $('#presse-loading');

    if (!$grid.length || !$loadMore.length) return;

    function setLoading(isLoading) {
      if (isLoading) {
        $loading.fadeIn(150);
        $grid.css('opacity', 0.45);
        $loadMore.addClass('loading').prop('disabled', true);
      } else {
        $loading.fadeOut(150);
        $grid.css('opacity', 1);
        $loadMore.removeClass('loading').prop('disabled', false);
      }
    }

    function fetchNext(url) {
      setLoading(true);

      $.ajax({
        url: url,
        method: 'GET',
        dataType: 'html',

        success: function (html) {
          const $temp = $('<div>').html(html);

          // Root wrapper returned by blog.presse-ajax.liquid
          const $root = $temp.find('#presse-ajax-root');

          // Items must be inside root
          const $items = $root.length ? $root.find('.presse-card') : $temp.find('.presse-card');

          // Next URL is provided by server (paginate.next.url)
          const nextUrl = ($root.attr('data-next-url') || '').trim();

          if (!$items.length) {
            // Nothing returned -> treat as end
            $loadMore.hide();
            setLoading(false);
            return;
          }

          $items.each(function () {
            $grid.append(this);
          });

          if (nextUrl) {
            $loadMore.attr('data-next-url', nextUrl).show();
          } else {
            // End reached
            $loadMore.hide();
          }

          setLoading(false);
        },

        error: function () {
          $loadMore.hide();
          setLoading(false);
        }
      });
    }

    $loadMore.on('click', function () {
      if ($loadMore.hasClass('loading')) return;

      const nextUrl = ($loadMore.attr('data-next-url') || '').trim();
      if (!nextUrl) {
        $loadMore.hide();
        return;
      }

      fetchNext(nextUrl);
    });

  });
})(jQuery);
